import React from 'react'
import ReactSVG from 'react-svg'

import neonLoadingImg from '../../../../../images/neon/loading-white.svg'
import styles from './searching.css'

function Searching() {
  return (
    <div className={styles.wrapper}>
      <ReactSVG
        src={neonLoadingImg}
        evalScripts="never"
      />
    </div>
  )
}

Searching.propTypes = { }

export default Searching
